import React, { ReactNode } from 'react';
import { X } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';
import ButtonCircle from '@/components/ui/ButtonCircle';
interface TimelineSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  className?: string;
  title: string;
  headerContent?: ReactNode;
  children: ReactNode;
  inputContent?: ReactNode;
  footerContent?: ReactNode;
}
const TimelineSidebar = ({
  isOpen,
  onClose,
  className,
  title,
  headerContent,
  children,
  inputContent,
  footerContent
}: TimelineSidebarProps) => {
  const isMobile = useIsMobile();
  return <div className={`
      bg-white/20 backdrop-blur-xl border-l border-white/20 shadow-2xl flex flex-col h-full
      ${isMobile ? 'w-full' : 'w-[400px]'}
      ${className || ''}
    `}>
      {/* Sidebar Header */}
      <div className="flex items-center justify-between p-4 border-b border-white/20 flex-shrink-0">
        <div className="flex flex-col items-start">
          <h2 className="text-lg font-semibold text-gray-900">
            {title}
          </h2>
          {headerContent}
        </div>
        <ButtonCircle onClick={onClose} size="small" aria-label="Close" className="hover:bg-white/20">
          <X className="h-4 w-4" />
        </ButtonCircle>
      </div>

      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto">
        {children}
      </div>

      {/* Input Area */}
      {inputContent && <div className="flex-shrink-0 border-t border-white/20">
          {inputContent}
        </div>}

      {/* Footer */}
      {footerContent && <div className="flex-shrink-0">
          {footerContent}
        </div>}
    </div>;
};
export default TimelineSidebar;